import React, { useRef, useState } from "react";
import "./Videos.css";
import { useLanguage } from "../LanguageContext";

// Importing video files
import video1 from "../videos/video1.mp4";
import video2 from "../videos/video2.mp4";
import video3 from "../videos/video3.mp4";
import alfiaPoster from "../images/alfia.png";
import montePreviewImage from "../images/Monte.jpeg";

const videoItems = [
  {
    id: 4,
    type: "youtube",
    embed: "https://www.youtube.com/embed/Iq_kmDGil-I?start=50",
    link: "https://www.youtube.com/watch?v=Iq_kmDGil-I&t=50s",
    isNew: true,
    title_ar: "لقاء تلفزيوني: نشرة أخبار القناة الأولى (بالفرنسية)",
    title_fr: "Passage JT francophone",
    title_en: "Interview on Al Aoula French News",
    subtitle_ar: "على قناة الأولى",
    subtitle_fr: "Al Aoula",
    subtitle_en: "Al Aoula",
  },
  {
    id: 6,
    type: "external",
    link: "https://www.mc-doualiya.com/%D8%A8%D8%B1%D8%A7%D9%85%D8%AC/%D9%83%D8%A7%D9%81%D9%8A%D9%87-%D8%B4%D9%88/20260704-%D9%87%D8%A7%D8%AC%D8%B1-%D8%A3%D9%88%D8%AD%D8%B3%D9%8A%D9%86-%D8%AF%D9%8A%D9%88%D8%A7%D9%86%D9%8A-habiter-le-presque-%D8%AF%D8%B9%D9%88%D8%A9-%D9%84%D9%84%D8%AA%D8%B5%D8%A7%D9%84%D8%AD-%D9%85%D8%B9-%D8%A7%D9%84%D9%87%D8%B4%D8%A7%D8%B4%D8%A9?fbclid=IwY2xjawTSps5wZG9mBWV4dG4DYWVtAjEwAGJyaWQRMXU0TlB4elh6QjlWM29sT3NzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeIJNCLWxYiBRoUqWZWO_Hscenia5IfdxczNp799P8iUcgehNhknzdLn-FttM_aem_LLuus_ZpaxwhXZFBcsj0Hw",
    title_ar: "بودكاست",
    title_fr: "Passage Radio",
    title_en: "Radio appearance",
    subtitle_ar: "مونتي كارلو الدولية",
    subtitle_fr: "Monte Carlo Doualiya",
    subtitle_en: "Monte Carlo Doualiya",
    previewImage: montePreviewImage,
  },
  {
    id: 1,
    type: "video",
    src: video1,
    title_ar: "Passage à Pop-Up News (2M TV)",
    title_fr: "Passage à Pop-Up News (2M TV)",
    title_en: "Appearance on Pop-Up News (2M TV)",
    subtitle_ar: "عن إصداري الأول أضغاث أحلام",
    subtitle_fr: "À propos de mon premier ouvrage",
    subtitle_en: "About my first book",
  },
  {
    id: 2,
    type: "video",
    src: video2,
    poster: alfiaPoster,
    title_ar: "مقابلة",
    title_fr: "Interview",
    title_en: "Interview",
    subtitle_ar: "مع مكتبة الألفية",
    subtitle_fr: "à la bibliothèque Alifia",
    subtitle_en: "at Alifia Library",
  },
  {
    id: 3,
    type: "video",
    src: video3,
    title_ar: "ظهور إعلامي",
    title_fr: "Apparition médiatique",
    title_en: "Media appearance",
    subtitle_ar: "على قناة ميدي 1 تيفي",
    subtitle_fr: "sur MEDI 1 TV",
    subtitle_en: "on MEDI 1 TV",
  },
];

function Videos() {
  const { language } = useLanguage();
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollAmount = 350;
    container.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
  };

  const [selectedItem, setSelectedItem] = useState(null);
  const openModal = (item) => setSelectedItem(item);
  const closeModal = () => setSelectedItem(null);

  return (
    <div className="videos-section">
      <h2 className="section-title videos-title">
        {language === 'ar' ? 'حوارات' : language === 'fr' ? 'Interviews' : 'Interviews'}
      </h2>

      <div className="carousel-wrapper">
        <button className="carousel-nav-btn prev" onClick={() => scroll('left')}>
          &#8249;
        </button>

        <div className="videos-container" ref={scrollRef}>
          {videoItems.map((item) => (
            <div className="video-card" key={item.id}>
              {item.isNew && (
                <span className="new-badge">
                  {language === 'ar' ? 'جديد' : language === 'fr' ? 'Nouveau' : 'New'}
                </span>
              )}

              {/* Card preview - clicking opens modal */}
              {item.type === 'video' ? (
                <div className="video-preview" onClick={() => openModal(item)} role="button" tabIndex={0} onKeyPress={(e)=>{ if(e.key==='Enter') openModal(item)}}>
                  <video className="video-player" src={item.src} poster={item.poster} muted />
                  <div className="play-overlay"><span>▶</span></div>
                </div>
              ) : item.type === 'external' ? (
                item.link ? (
                  <a className="video-preview external-preview" href={item.link} target="_blank" rel="noreferrer noopener">
                    {item.previewImage ? (
                      <img className="video-player" src={item.previewImage} alt={language === 'ar' ? item.title_ar : language === 'fr' ? item.title_fr : item.title_en} />
                    ) : (
                      <div className="external-preview-content">
                        <div className="external-preview-icon">🔊</div>
                        <div className="external-preview-title">
                          {language === 'ar' ? item.title_ar : language === 'fr' ? item.title_fr : item.title_en}
                        </div>
                      </div>
                    )}
                  </a>
                ) : (
                  <div className="video-preview external-preview">
                    <div className="external-preview-content">
                      <div className="external-preview-icon">🔊</div>
                      <div className="external-preview-title">
                        {language === 'ar' ? item.title_ar : language === 'fr' ? item.title_fr : item.title_en}
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <div className="video-preview" onClick={() => openModal(item)} role="button" tabIndex={0} onKeyPress={(e)=>{ if(e.key==='Enter') openModal(item)}}>
                  {/* Use YouTube thumbnail as preview image */}
                  <img className="video-player" src={`https://img.youtube.com/vi/${getYouTubeId(item.link)}/hqdefault.jpg`} alt={item.title_en} />
                  <div className="play-overlay"><span>▶</span></div>
                </div>
              )}

              <div className="video-info">
                <div>
                  <h3 className="video-title">
                    {language === 'ar' ? item.title_ar : language === 'fr' ? item.title_fr : item.title_en}
                  </h3>
                  <p className="video-subtitle">
                    {language === 'ar' ? item.subtitle_ar : language === 'fr' ? item.subtitle_fr : item.subtitle_en}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-nav-btn next" onClick={() => scroll('right')}>
          &#8250;
        </button>
      </div>
        {selectedItem && (
          <div className="video-modal-overlay" onClick={closeModal}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-modal" onClick={closeModal}>&times;</button>
              {selectedItem.type === 'video' ? (
                <video className="modal-video" src={selectedItem.src} controls autoPlay />
              ) : (
                <iframe
                  className="modal-video"
                  title={selectedItem.title_en}
                  src={selectedItem.embed}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </div>
        )}
    </div>
  );
}

  // helper to extract YouTube ID from link
  function getYouTubeId(url) {
    try {
      const m = url.match(/v=([\w-]+)/);
      if (m && m[1]) return m[1];
      const m2 = url.match(/youtu\.be\/([\w-]+)/);
      if (m2 && m2[1]) return m2[1];
      return '';
    } catch (e) {
      return '';
    }
  }

export default Videos;
